import { motion } from "framer-motion";
import React from "react";
import CvContent from "../components/Cv/Cv";

// Pagina /cv: link diretto, non presente nel menu
const Cv = () => (
  <motion.main initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }}>
    <CvContent />
  </motion.main>
);

export default Cv;
